import type { TypeArticleWithoutUnresolvableLinksResponse } from '~/types/contentful'

export default defineNuxtPlugin(() => {
  const userAccessCheck = (
    level: TypeArticleWithoutUnresolvableLinksResponse['fields']['accessLevel'],
    highestUserLevel: number,
  ) => {
    // If level is undefined or null, allow it through the filter
    if (!level) return true

    // Extract the numeric part of the level string
    const levelNumber = parseInt(level.split(' ')[1])

    // Compare the extracted level number with the highestUserLevel
    // If the highestUserLevel is less than the level number, filter it out
    return highestUserLevel >= levelNumber
  }

  return {
    provide: {
      userAccessCheck,
    },
  }
})
